import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LoopInterface } from '../+models';

export const LOOP_SERVICE_TOKEN = new InjectionToken('LoopServiceInterface');

export interface LoopServiceInterface {
  getAllForUser(userId: number): Observable<LoopInterface[]>;
}
